// extracted by mini-css-extract-plugin
module.exports = {"container":"SCurveIntro-module--container--1cbia"};